import { Injectable, Inject, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { SubProductsComponent } from '../pages/home/components/sub-products/sub-products.component';

@Injectable({ providedIn: 'root' })
export class AlertsService {

  constructor(
    private dialog: MatDialog,
  ) {
  }

  openDialog(relativeElement: ElementRef<HTMLElement>) {
    this.dialog.open(SubProductsComponent, {
      hasBackdrop: true,
      height: '355px',
      width: '364px',
      data: { positionRelativeToElement: relativeElement },
      panelClass: 'custom-dialog-container'
    });
  }
}
